import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip);

interface Props {
  value: number; // from 0 to 100
}

export default function CircularProgressChart({ value }: Props) {
  const data = {
    datasets: [
      {
        data: [value, 100 - value],
        backgroundColor: ['#12AFBD', '#e5e7eb'], // green + gray
        borderWidth: 0,
        cutout: '80%', // Inner radius
      },
    ],
  };

  const options = {
    rotation: -90,
    circumference: 360, // optional for semi-circle
    plugins: {
      tooltip: { enabled: false },
    },
  };

  return (
    <div className="relative w-[66px] h-[66px]">
      <Doughnut data={data} options={options} style={{ marginTop: -10 }} />
      <div className="absolute inset-0 flex items-center justify-center -mt-3 ml-1 text-[10px] font-semibold text-oh-primary">
        {value}%
      </div>
    </div>
  );
}